import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';
import { FeedbackSurveyQuestion } from '../models';


const KEY_ACTION = ActionType.AddQuestionsForCompetencyRequest;
const ACTIONS    = [
  ActionType.AddQuestionsForCompetencyRequest,
  ActionType.AddQuestionsForCompetencyResponse,
  ActionType.AddQuestionsForCompetencyError,
];


type Payload = FeedbackSurveyQuestion[];

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to add a dev plan item
 */
export const addQuestionsForCompetencyAction = (
  projectId: number,
  participantId: number,
  competencyId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.AddQuestionsForCompetency,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    projectId:     projectId,
    participantId: participantId,
    competencyId: competencyId,
    languageId: state.locale.lang.languageId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['selectedQuestions', `${action.meta.projectId}`],
    (successState.selectedQuestions?.[`${action.meta.projectId}`] || []).concat(payload),
    successState,
  );  
};


export const addQuestionsForCompetencyReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
